<template>
  <v-dialog v-model="openModal" max-width="430">
    <v-card class="pt-4 pb-2">
      <v-card-title class="title">
        <v-icon size="60" color="vermelho-d20">warning</v-icon>
        <h1>{{ title }}</h1>
      </v-card-title>
      <v-card-text class="ma-0">
        <p class="description">{{ description }}</p>

        <mf-action-buttons
          class="mt-2"
          :secondary-button="{
            text: 'Fechar',
            action: closeModal,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OfferScheduleErrorDialog',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    isNewOffer: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    openModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    title() {
      if (this.isNewOffer) {
        return 'Falha na criação'
      }
      return 'Falha na edição'
    },
    description() {
      if (this.isNewOffer) {
        return 'Ocorreu algum erro no processamento dessa oferta, você pode  tentar novamente mais tarde ou entrar em contato com o nosso suporte.'
      }
      return 'Ocorreu algum erro no processamento dessa oferta, as alterações realizadas não foram salvas e a campanha segue como estava. Tente alterar novamente mais tarde ou entre em contato com o suporte. '
    },
  },
  methods: {
    closeModal() {
      this.openModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;

  h1 {
    font-weight: bold;
    color: $cinza-d10;
    font-size: 26px;
    margin: 0;
  }
}

.description {
  margin-top: 12px;
  color: $cinza-0;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
</style>
